import List from "@/components/list";
import vue from "@/main.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    vue.$emit("deleteDrafts", row);
  }

  function handleEdit({ row }) {
    vue.$emit("editDrafts", row);
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-edit", "编辑", () => handleEdit(vo), "drafts:info"],
      ["icon-delete", "删除", () => handleDelete(vo), "drafts:delete"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "消息模板",
      prop: "mqTemplate",
      showOverflowTooltip: true
    },
    {
      label: "消息分类",
      prop: "mqInfoTypeName"
    },
    {
      label: "最后编辑人",
      prop: "modifyUserName"
    },
    {
      label: "最后保存时间",
      prop: "modifyDate"
    },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
